import React from "react"
import { Flex } from "theme-ui"
import styled from "@emotion/styled"
import CareersCard from "components/cards/careers-card"

const CareersWrapper = styled(Flex)`
    margin: auto;
    flex-wrap: no-wrap;
    flex-direction: column;
    justify-content: space-between;
`

// markup
const IndexPage = ({ data, url }) => {
    return (
        <CareersWrapper>
            {data.edges.map((career, idx) => {
                const { node } = career
                return (
                    <CareersCard
                        key={idx}
                        url={url}
                        slug={node.slug}
                        title={node.title}
                        emp_type={node.employment_type}
                    />
                )
            })}
        </CareersWrapper>
    )
}

export default IndexPage
